import React from 'react';
import { Container, Col } from 'reactstrap';
import { RecipeForm } from '../Form'
import { RouteComponentProps } from 'react-router-dom';
import { Recipe } from 'state/recipe/model';

interface State {
  units: string[]
}

interface Props extends RouteComponentProps<any> {
  createRecipe(recipe: Recipe): void
}

export default class NewRecipe extends React.PureComponent<Props, State> {
  constructor(props: any) {
    super(props);
  }

  onSubmit = (recipe: Recipe) => {
    this.props.createRecipe(recipe);
  }

  render() {
    return (
      <div>
        <Container>
          <Col md={10}>
            <h1>New Recipe</h1>
            <RecipeForm
              defaultValue={{ name: '', instructions: '', ingredients: [] }}
              onSubmit={this.onSubmit}
              location={this.props.location.pathname}
            />
          </Col>
        </Container>
      </div>
    )
  }
}